import React, { useState } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { complimentPost } from "../../Helpers/backendHelper"; // Ensure complimentPost returns the correct data type
import { useMutation, UseMutationResult } from "react-query";

// Define the types for the props
interface ComplimentsProps {
  postId: number; // or number, depending on your data type
  initialLikes: number;
  isLiked: boolean;
  setIsLiked: React.Dispatch<React.SetStateAction<boolean>>;
}

// Define the type for the data returned by the mutation
interface ComplimentPostData {
  likes?: number;
}

export const Compliments: React.FC<ComplimentsProps> = ({
  postId,
  initialLikes,
  isLiked,
  setIsLiked,
}) => {
  const [compliments, setCompliments] = useState<number>(initialLikes);

  const mutation: UseMutationResult<
    ComplimentPostData,
    unknown,
    { post_id: number }
  > = useMutation(
    async (variables: { post_id: number }) => {
      const response = await complimentPost({ post_id: variables.post_id });
      return response.data; // Assuming `complimentPost` returns the data directly
    },
    {
      onSuccess: (data) => {
        if (data.likes !== undefined) {
          setCompliments(data.likes);
          setIsLiked(!isLiked);
        }
      },
    },
  );

  const handleSetCompliments = () => mutation.mutate({ post_id: postId });

  return (
    <div className="flex items-center gap-1">
      <div
        onClick={handleSetCompliments}
        className={`icon-container transition-all duration-300 cursor-pointer ${
          isLiked ? "scale-90" : ""
        }`}
      >
        {isLiked ? (
          <CheckCircleIcon color="success" />
        ) : (
          <CheckCircleOutlineIcon color="inherit" />
        )}
      </div>
      {compliments !== 0 && (
        <span>
          {compliments}{" "}
          <span className="hidden md:inline">
            Compliment{compliments > 1 ? "s" : ""}
          </span>
        </span>
      )}
    </div>
  );
};

export default Compliments;
